import { useTheme } from '@emotion/react';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MoreVertSharpIcon from '@mui/icons-material/MoreVertSharp';
import {
  Box,
  Grid,
  IconButton,
  InputBase,
  MenuItem,
  Select,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material';
import {
  getBuyerContact,
  getBuyerContactAgent,
  getBuyerContactSolicitor,
  getContactDetails,
  getVendorContact,
  getVendorContactAgent,
  getVendorContactSolicitor,
  getBuyerDetails,
  getOwnerDetails,
} from 'api/apiService';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { ReactComponent as OrderBy } from 'assets/icons/order.svg';
import { ReactComponent as SortBy } from 'assets/icons/sortBy.svg';
import { ReactComponent as Search } from 'assets/svg/headersearch.svg';
import searchIcon from 'assets/svg/searchIcon.svg';
import { textTransform } from 'component/PropertyContainer/PropertyContainer.style';
import PropTypes from 'prop-types';
import * as React from 'react';
import { poppins400 } from 'theme/common.style';
import ContactTabItem from './ContactAllTabItem';
import ContactBuyerTabItem from './ContactBuyerTabItem';
import ContactOwnerTabItem from './ContactOwnerTabItem';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Cancelicon } from 'assets/svgfunctions/commonsvg';
const headCells = [
  {
    id: 'name',
    numeric: false,
    disablePadding: true,
    label: 'Name',
  },
  {
    id: 'contact',
    numeric: true,
    disablePadding: false,
    label: 'Contact',
  },
  {
    id: 'buyerreadlines',
    numeric: true,
    disablePadding: false,
    label: 'Buyer Readlines',
  },
  {
    id: 'status',
    numeric: true,
    disablePadding: false,
    label: 'Status',
  },
  {
    id: 'offer',
    numeric: true,
    disablePadding: false,
    label: 'Offer',
  },
  {
    id: 'noofoffer',
    numeric: true,
    disablePadding: false,
    label: 'Number of offers',
  },
  {
    id: 'propertyrating',
    numeric: true,
    disablePadding: false,
    label: 'Property Rating',
  },
  {
    id: 'exp',
    numeric: true,
    disablePadding: false,
    label: 'Exp',
  },
  {
    id: 'profile',
    numeric: true,
    disablePadding: false,
    label: 'Profile',
  },
  {
    id: 'action',
    numeric: true,
    disablePadding: false,
    label: 'Action Required',
  },
];
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
export const ToggleOff = () => {
  return (
    <svg
      width="42"
      height="25"
      viewBox="0 0 42 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.459961"
        y="0.370483"
        width="41.54"
        height="24.3705"
        rx="12.1852"
        fill="#DFDFDF"
      />
      <ellipse
        cx="12.981"
        cy="12.5557"
        rx="8.52103"
        ry="8.86199"
        fill="white"
      />
    </svg>
  );
};
export const contactErrorContext = React.createContext();

export default function BasicTabs({
  setSelectedRows,
  setOpenInvite,
  setExportAnchorEl,
  onContactsDataChange,
  selectedRows,
}) {
  const [contextErrorMessage, setContextErrorMessage] = React.useState('');
  const [value, setValue] = React.useState(0);
  const [searchField, setSearchField] = React.useState(false);
  const [tabAlign, setTabAlign] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState(false);
  const userType = localStorage.getItem('primaryUser');
  const userTypeParse = JSON.parse(userType);
  const [searchText, setSearchText] = React.useState('');

  const [allCount, setAllCount] = React.useState(0);
  const [secondTabCount, setSecondTabCount] = React.useState(0);
  const [thirdTabCount, setThirdTabCount] = React.useState(0);

  const [allContactsData, setAllContactsData] = React.useState([]);
  const [buyerContactsData, setBuyerContactsData] = React.useState([]);
  const [ownerContactsData, setOwnerContactsData] = React.useState([]);

  const handleAllContactsData = (data) => {
    setAllContactsData(data);
    if (onContactsDataChange) {
      onContactsDataChange('all', data);
    }
  };

  const handleBuyerContactsData = (data) => {
    setBuyerContactsData(data);
    if (onContactsDataChange) {
      onContactsDataChange('buyer', data);
    }
  };

  const handleOwnerContactsData = (data) => {
    setOwnerContactsData(data);
    if (onContactsDataChange) {
      onContactsDataChange('owner', data);
    }
  };

  const getCurrentTabData = () => {
    if (value === 0) return allContactsData;
    if (value === 1) return buyerContactsData;
    if (value === 2) return ownerContactsData;
    return [];
  };

  React.useEffect(() => {
    if (onContactsDataChange) {
      const currentData = getCurrentTabData();
      onContactsDataChange('current', currentData);
    }
  }, [value, allContactsData, buyerContactsData, ownerContactsData]);

  React.useEffect(() => {
    const getUserCount = (response) =>
      Array.isArray(response?.userDetails) ? response.userDetails.length : 0;

    const getTabCounts = async () => {
      try {
        if (userTypeParse === 'Buyer') {
          const allResp = await getBuyerContact(userTypeParse);

          setAllCount(allResp?.data?.length || 0);

          const agentResp = await getBuyerContactAgent();
          setSecondTabCount(agentResp?.data?.length || 0);

          const solicitorResp = await getBuyerContactSolicitor();
          setThirdTabCount(solicitorResp?.data?.length || 0);
        } else if (userTypeParse === 'Vendor') {
          const allResp = await getVendorContact(userTypeParse);
          setAllCount(allResp?.data?.length || 0);

          const agentResp = await getVendorContactAgent();
          setSecondTabCount(agentResp?.data?.length || 0);

          const solicitorResp = await getVendorContactSolicitor();
          setThirdTabCount(solicitorResp?.data?.length || 0);
        } else {
          const allResp = await getContactDetails();
          setAllCount(getUserCount(allResp));

          const buyerResp = await getBuyerDetails();
          setSecondTabCount(getUserCount(buyerResp));

          const ownerResp = await getOwnerDetails();
          setThirdTabCount(getUserCount(ownerResp));
        }
      } catch (err) {
        console.error(err);
      }
    };

    getTabCounts();
  }, []);
  const handleChange = (event, newValue) => {
    setContextErrorMessage('Loading...');
    setValue(newValue);
    setSelectedRows([]);
    setOpenInvite(false);
    setExportAnchorEl(null);
  };

  const handleNextTab = () => {
    setValue((prev) => (prev < 2 ? prev + 1 : prev));
    setSelectedRows([]);
    setOpenInvite(false);
    setExportAnchorEl(null);
  };

  const handlePrevTab = () => {
    setValue((prev) => (prev > 0 ? prev - 1 : prev));
    setSelectedRows([]);
    setOpenInvite(false);
    setExportAnchorEl(null);
  };

  const theme = useTheme();
  const matches1000 = useMediaQuery(theme.breakpoints.between(1535, 1700));
  const showArrow = useMediaQuery(theme.breakpoints.down(460));
  const match900 = useMediaQuery(theme.breakpoints.down(900));
  const match600 = useMediaQuery(theme.breakpoints.down(600));
  const match1200 = useMediaQuery(theme.breakpoints.down(1200));
  const match1000 = useMediaQuery(theme.breakpoints.down(1080));

  const hasContacts = allCount > 0 || secondTabCount > 0 || thirdTabCount > 0;

  return (
    <Grid container>
      {!searchValue && (
        <Grid
          xs={12}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <Grid
            container
            display={'flex '}
            flexDirection={'row'}
            justifyContent={'space-between'}
            // xs={12}
          >
            {!tabAlign && (
              <Grid
                item
                style={{ padding: '0px 15px 0px 15px' }}
                // xs={match1000 ? 12 : 3}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginLeft: '15px',
                }}
              >
                {!searchField && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: showArrow ? '160px' : 'auto',
                    }}
                  >
                    {showArrow && (
                      <IconButton
                        onClick={handlePrevTab}
                        disabled={value === 0}
                        sx={{ padding: '4px' }} // Reduce padding to make the button smaller
                      >
                        <ArrowBackIosNewIcon sx={{ fontSize: '16px' }} />{' '}
                        {/* Reduce icon size */}
                      </IconButton>
                    )}
                    {hasContacts && (
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="standard"
                        sx={{
                          minHeight: 36,

                          '& .MuiTabs-flexContainer': {
                            gap: '8px',
                          },
                          '& .MuiTabs-indicator': {
                            height: 0,
                            backgroundColor: 'transparent',
                            display: 'none !important',
                          },

                          '& .MuiTab-root': {
                            height: '36px',
                            minHeight: 36,
                            width: '90px',
                            minWidth: '90px',
                            padding: '8px 16px',
                            borderRadius: '18px',
                            background: '#FFFFFF',
                            border: '1px solid #E6E6E6',
                            color: '#666666',
                            textTransform: 'none',
                            fontSize: '12px',
                            fontWeight: 500,
                          },

                          '& .MuiTab-root.Mui-selected': {
                            background: '#EFE7F8',
                            border: '1px solid #C9B2F4',
                            color: '#6C2AD2',
                          },
                          '& .MuiTab-root.Mui-selected::after': {
                            display: 'none',
                            content: 'none',
                          },
                        }}
                      >
                        <Tab
                          label={`All${allCount > 0 ? ` ${allCount}` : ''}`}
                          {...a11yProps(0)}
                          sx={textTransform}
                        />
                        <Tab
                          label={
                            userTypeParse === 'Agent'
                              ? `Buyer${
                                  secondTabCount > 0 ? ` ${secondTabCount}` : ''
                                }`
                              : `Agent${
                                  secondTabCount > 0 ? ` ${secondTabCount}` : ''
                                }`
                          }
                          {...a11yProps(1)}
                          sx={textTransform}
                        />
                        <Tab
                          label={
                            userTypeParse === 'Agent'
                              ? `Owner${
                                  thirdTabCount > 0 ? ` ${thirdTabCount}` : ''
                                }`
                              : `Solicitor${
                                  thirdTabCount > 0 ? ` ${thirdTabCount}` : ''
                                }`
                          }
                          {...a11yProps(2)}
                          sx={textTransform}
                        />
                      </Tabs>
                    )}

                    {showArrow && (
                      <IconButton
                        onClick={handleNextTab}
                        disabled={value === 2}
                        sx={{ padding: '4px' }} // Reduce padding to make the button smaller
                      >
                        <ArrowForwardIosIcon sx={{ fontSize: '16px' }} />{' '}
                        {/* Reduce icon size */}
                      </IconButton>
                    )}
                  </div>
                )}
              </Grid>
            )}
            {!match1200 && hasContacts && (
              <Grid
                item
                // container
                // xs={match1000 ? 12 : 9}
                display={'flex'}
                flexDirection={'column'}
                marginLeft={'20px'}
                sx={{ marginRight: '20px' }}
              >
                <Grid
                  container
                  item
                  sx={{
                    alignItems: 'center',
                    gap: '10px',
                    justifyContent: match900 ? 'start' : 'end',
                  }}
                >
                  <Grid item>
                    <Box
                      component="form"
                      sx={{
                        // p: "2px 4px",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        // backgroundColor:"green",
                        // width: matchesbet67 ? "80%" : "100%",
                        width: '100%',
                        backgroundColor: '#F2F2F2',
                        borderRadius: '30px',
                        height: '40px',
                      }}
                    >
                      <IconButton
                        disabled
                        sx={{ p: '10px', paddingLeft: '20px' }}
                        aria-label="search"
                      >
                        <img alt="searchIcon" src={searchIcon} />
                      </IconButton>
                      <InputBase
                        sx={{
                          ml: 1,
                          flex: 1,
                          '& ::placeholder': {
                            color: '#66666 !important',
                            fontSize: '14px',
                            fontWeight: 400,
                            fontFamily: 'poppins',
                            opacity: 1,
                          },

                          fontSize: '14px',
                          fontWeight: 400,
                          fontFamily: 'poppins',
                        }}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        placeholder="Search Contacts"
                        inputProps={{
                          'aria-label': 'Search Contacts',
                        }}
                      />
                      {searchText && (
                        <IconButton
                          onClick={() => setSearchText('')}
                          sx={{ p: '8px', mr: 1 }}
                        >
                          <Cancelicon />
                        </IconButton>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            )}
            {hasContacts && tabAlign && (
              <Grid
                item
                // container
                // xs={match1000 ? 12 : 9}
                display={'flex'}
                marginTop={'5px'}
                flexDirection={'column'}
                marginLeft={'auto'}
                // style={{ padding: "10px 24px 10px 24px" }}
              >
                <Grid
                  container
                  item
                  sx={{
                    alignItems: 'center',
                    gap: '10px',
                    // justifyContent: match900 ? "start" : "end",
                  }}
                >
                  {/* {!match900 && ( */}
                  <Grid item>
                    {!match900 && (
                      <Box
                        component="form"
                        sx={{
                          // p: "2px 4px",
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          // backgroundColor:"green",
                          // width: matchesbet67 ? "80%" : "100%",
                          width: '100%',
                          backgroundColor: '#F2F2F2',
                          borderRadius: '30px',
                          height: '40px',
                        }}
                      >
                        <IconButton
                          disabled
                          sx={{ p: '10px', paddingLeft: '20px' }}
                          aria-label="search"
                        >
                          <img alt="searchIcon" src={searchIcon} />
                        </IconButton>
                        <InputBase
                          sx={{
                            ml: 1,
                            flex: 1,
                            '& ::placeholder': {
                              color: '#66666 !important',
                              fontSize: '14px',
                              fontWeight: 400,
                              fontFamily: 'poppins',
                              opacity: 1,
                            },

                            fontSize: '14px',
                            fontWeight: 400,
                            fontFamily: 'poppins',
                          }}
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                          placeholder="Search Contacts"
                          inputProps={{
                            'aria-label': 'Search Contacts',
                          }}
                        />
                        {searchText && (
                          <IconButton
                            onClick={() => setSearchText('')}
                            sx={{ p: '8px', mr: 1 }}
                          >
                            <Cancelicon />
                          </IconButton>
                        )}
                      </Box>
                    )}
                    {hasContacts && match900 && (
                      <Search onClick={() => setSearchValue(true)} />
                    )}
                  </Grid>
                </Grid>
              </Grid>
            )}
            {hasContacts && match1200 && (
              <IconButton onClick={() => setTabAlign(!tabAlign)}>
                <Box
                  borderRadius="50%"
                  width={40}
                  height={40}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ border: '1px solid #F0F0F0' }}
                  marginRight={'15px'}
                >
                  {tabAlign ? <MoreHorizIcon /> : <MoreVertSharpIcon />}
                </Box>
              </IconButton>
            )}
          </Grid>
        </Grid>
      )}
      {hasContacts && searchValue && (
        <Box
          component="form"
          sx={{
            // p: "2px 4px",
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: 'auto',
            width: '85%',
            backgroundColor: '#F2F2F2',
            borderRadius: '30px',
            height: '49px',
          }}
        >
          <IconButton
            disabled
            sx={{ p: '10px', paddingLeft: '20px' }}
            aria-label="search"
          >
            <img alt="searchIcon" src={searchIcon} />
          </IconButton>
          <InputBase
            sx={{
              ml: 1,
              flex: 1,
              '& input::placeholder': {
                color: '#666666 !important',
                fontSize: '14px',
                fontWeight: 400,
                fontFamily: 'poppins',
                opacity: 1,
              },

              fontSize: '14px',
              fontWeight: 400,
              fontFamily: 'poppins',
            }}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search Contacts"
            inputProps={{
              'aria-label': 'Search Contacts',
            }}
          />
          <IconButton
            sx={{ p: '10px', paddingRight: '20px' }}
            aria-label="search"
            onClick={() => {
              setSearchText('');
              setSearchValue(false);
            }}
          >
            <Cancelicon />
          </IconButton>
        </Box>
      )}
      <contactErrorContext.Provider
        value={{ contextErrorMessage, setContextErrorMessage }}
      >
        <Grid
          xs={12}
          sx={{
            overflowY: 'scroll',
            '-webkit-scrollbar': {
              display: 'none',
            },
            '-ms-overflow-style': 'none' /* IE and Edge */,
            'scrollbar-width': 'none',
          }}
        >
          <TabPanel value={value} index={0}>
            <ContactTabItem
              userType={userTypeParse}
              user={'AgentAll'}
              setCount={setAllCount}
              setSelectedRows={setSelectedRows}
              selectedRows={selectedRows}
              onDataLoad={handleAllContactsData}
              searchText={searchText}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            {userTypeParse == 'Agent' ? (
              <ContactBuyerTabItem
                userType={userTypeParse}
                setCount={setSecondTabCount}
                setSelectedRows={setSelectedRows}
                selectedRows={selectedRows}
                onDataLoad={handleBuyerContactsData}
                searchText={searchText}
              />
            ) : (
              <ContactTabItem
                userType={userTypeParse}
                user={userTypeParse == 'Buyer' ? 'buyerAgent' : 'vendorAgent'}
                setCount={setAllCount}
                setSelectedRows={setSelectedRows}
                selectedRows={selectedRows}
                onDataLoad={handleBuyerContactsData}
                searchText={searchText}
              />
            )}
          </TabPanel>
          <TabPanel value={value} index={2}>
            {userTypeParse == 'Agent' ? (
              <ContactOwnerTabItem
                userType={userTypeParse}
                setCount={setThirdTabCount}
                setSelectedRows={setSelectedRows}
                onDataLoad={handleOwnerContactsData}
                selectedRows={selectedRows}
                searchText={searchText}
              />
            ) : (
              <ContactTabItem
                userType={userTypeParse}
                user={
                  userTypeParse == 'Buyer'
                    ? 'buyerSolicitor'
                    : 'vendorSolicitor'
                }
                setCount={setAllCount}
                setSelectedRows={setSelectedRows}
                selectedRows={selectedRows}
                onDataLoad={handleOwnerContactsData}
                searchText={searchText}
              />
            )}
          </TabPanel>
        </Grid>
      </contactErrorContext.Provider>
    </Grid>
  );
}
